export const CUTTER_ITEM_MEDIA_PLAYER_LOADED = 'Mimir Video Player (Loaded)';
export const CUTTER_ITEM_MEDIA_PLAYER_NOT_LOADED = 'Mimir Video Player (Not loaded)';
export const CUTTER_PREVIEW_PLAYER_CANVAS = 'Cutter Preview Canvas';

